import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";

const state = {};

const mutations = {};

const actions = {
  async updateDriver(_, payload) {
    const params = {
      ...payload.params,
    };
    const urlFormData = qs.stringify({ values: payload.data });
    try {
      const api = ApiClient();
      await api.put("drivers", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
    } catch (error) {
      console.error("ERROR en updateDriver: ", error.message);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
